<template>
    <div class="deal_refund_box">
        <!-- 申請退款 -->
        <div class="deal_title">
            <div>申請退款</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- BOX-go -->
        <div>
            <!-- 内容-1-交易及退款資訊 -->
            <div class="deal_content_box">
                <div class="deal_content_title">交易及退款資訊</div>
                <div class="deal_content">
                    <div>
                        <span>交易單號：</span><span class="left_span">420000002485018021050731479353</span>
                    </div>
                    <div>
                        <span>商家單號：</span><span class="left_span">SH420000002485018021050731</span>
                    </div>
                    <div>
                        <span>訂單金額：</span><span class="left_span">1元</span>
                        <div class="money_box">
                            <span class="">金融卡支付金額{{money.financial}}元</span><span>餘額支付金額{{money.balance}}元</span><span>代金卷/立即折扣金額{{money.voucher}}元</span>
                        </div>
                    </div>
                    <div>
                        <span>已申請退款金額：</span><span class="refund_money">{{money.refund}}元</span><el-button type="primary" class="money_button">查看已申請退款單</el-button>
                    </div>
                </div>
            </div>
             <!-- 内容-2-退款方式 -->
            <div class="deal_content_box">
                <div class="deal_content_title">退款方式</div>
                <div class="deal_content">
                    <div>
                        <el-radio v-model="refundRadio" label="1">原路退回</el-radio>
                    </div>
                </div>
            </div>
             <!-- 内容-3-退款資訊 -->
            <div class="deal_content_box">
                <div class="deal_content_title">退款資訊</div>
                <div class="deal_content">
                    <div>
                        *退款金額：
                        <el-input v-model="refundInput" placeholder="" class="input_box"></el-input>
                        <span class="money_number">
                            （最多 <span>{{money.financial}}</span>元）
                        </span>
                    </div>
                    <div class="textarea_dis">
                        退款原因：
                        <div>
                            <el-input type="textarea" :rows="3" placeholder="" v-model="textarea" class="textarea_box" resize="none"></el-input>
                            <p class="hint">非必填，若有填寫將連同退款一併顯示予使用者。<span>{{textareaNumber}}</span></p>
                        </div>
                    </div>
                    <div>
                        *交易密碼：
                        <el-input v-model="password" placeholder="請輸入8-20位元字符,必須包含數字、字母和符號" class="input_pass" maxlength="20" clearable></el-input>
                        <span class="input_pass_number" @click="forget()">
                            忘記交易密碼？
                        </span>
                    </div>
                </div>
            </div>
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginDealRefund',
    data() {
        return {
            money:{
                financial: '1',
                balance: '0.00',
                voucher: '0.00',
                refund: '1'
            },
            refundRadio: '1',
            refundInput: '',
            textarea: '',
            textareaNumber: '',
            password: ''
        }
    },
    methods: {
        forget() {
            this.$router.push("/forget");
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 申請退款 */
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        cursor: pointer;
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 5px 25px;
    }
    .deal_content > div {
        margin: 22px 0;
    }
    .deal_content > div > .left_span {
        margin-left: 68px;
    }
    .deal_content .money_box {
        margin-top: 22px;
        margin-left: 114px;
    }
    .deal_content .money_box span {
        padding: 0 20px;
    }
    .deal_content .money_box span+span {
        border-left: 1px solid ;
    }
    .refund_money {
        margin-left: 28px;
        margin-right: 20px;
    }
    .money_button {
        font-size: 11px;
        line-height: 11px;
        padding: 6px 14px;
    }
    .money_number {
        margin-left: 16px;
    }
    .money_number > span {
        color: #6ac259;
    }
    .textarea_dis {
        display: flex;
        justify-content: flex-start;
    }
    .hint {
        margin-left: 10px;
        margin-top: 8px;
        font-size: 9px;
        color: #666666;
    }
</style>
